var Rectangle =
/** @class */
function () {
  function Rectangle(x, y, width, height) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.left = x;
    this.right = x + width;
    this.top = y;
    this.bottom = y + height;
  }

  Rectangle.prototype.toJSON = function () {};

  return Rectangle;
}();

export { Rectangle };